<script>
import { DateTime } from 'luxon';

export default {
  props: {
    datetime: {
      type: String,
      required: true,
    },
    format: {
      type: String,
      default: 'DDD t',
    },
  },
  computed: {
    localDateTime() {
      return DateTime.fromISO(this.datetime, { zone: 'utc' }).setZone(this.timeZone);
    },
    formattedLocalTime() {
      return this.localDateTime.toFormat(this.format);
    },
    timeZone() {
      const meta = document.querySelector('meta[name="time-zone"]');
      if (!meta) return DateTime.local().zoneName
      return meta.content;
    }
  }
};
</script>

<template>
  <time :datetime="this.datetime">
    {{ formattedLocalTime }}
  </time>
</template>